import {FilterOp, OrderByDirection} from '@coolcolduk/firebase-util';
import {ContactMessageDb, ContactMessageState, mapContactMessageDbToType, type ContactMessage} from '@cp/model';
import {QuerySnapshot} from 'firebase/firestore';
import buildFirestoreQuery from '../../helper/firebase/buildFirestoreQuery';
import mapFirestoreDocs from '../../helper/firebase/mapFirestoreDocs';
import {FirestoreCursor} from '../../types/FirestoreCursor';
import getContactMessageCollection from './getContactMessageCollection';

export const CONTACT_MESSAGE_PAGE_SIZE = 10;

export interface ListContactMessageOptions {
  includeArchived?: boolean;
  includeRead?: boolean;
  includeUnread?: boolean;
}

export function listContactMessageQuery(
  options: ListContactMessageOptions = {},
  limit?: number,
  cursor?: FirestoreCursor,
): Promise<QuerySnapshot<ContactMessage, ContactMessageDb>> {
  const {includeArchived = false, includeRead = true, includeUnread = true} = options;
  const states: ContactMessageState[] = [];
  if (includeUnread) states.push(ContactMessageState.UNREAD);
  if (includeRead) states.push(ContactMessageState.READ);
  if (includeArchived) states.push(ContactMessageState.ARCHIVE);

  return buildFirestoreQuery(getContactMessageCollection(), {
    order: {field: 'createdAt', direction: OrderByDirection.DESC},
    ...(states.length > 0 ? {where: {field: 'state', operator: FilterOp.IN, value: states}} : {}),
    ...(cursor ? cursor : {}),
    ...(limit ? {limit} : {}),
  });
}

export default async function listContactMessage(
  options: ListContactMessageOptions,
  limit?: number,
  cursor?: FirestoreCursor,
): Promise<ContactMessage[]> {
  const snapshot = await listContactMessageQuery(options, limit, cursor);
  return mapFirestoreDocs(snapshot.docs, mapContactMessageDbToType);
}
